import { createReducer } from 'typesafe-actions';

import { CurrencyFiatResult } from '@block-explorer/entities';

import { setSelectedCurrency, getAvailableCurrencyListAsync } from './actions';
import { CURRENCIES } from '../../utils/currency';

export type State = {
  availableCurrencies: CurrencyFiatResult[] | null;
  selectedCurrency: CurrencyFiatResult;
  loading: boolean;
  error: string | null;
};
const initialState: State = {
  loading: false,
  error: null,
  selectedCurrency: {
    id: 1,
    type_id: 1,
    code: 'USD',
    title: CURRENCIES['USD'],
  },
  availableCurrencies: null,
};

export default createReducer(initialState)
  .handleAction(
    getAvailableCurrencyListAsync.success,
    (state, action): State => ({
      ...state,
      loading: false,
      error: null,
      availableCurrencies: action.payload.data,
    })
  )
  .handleAction(
    getAvailableCurrencyListAsync.request,
    (state, action): State => ({
      ...state,
      loading: true,
      error: null,
    })
  )
  .handleAction(
    getAvailableCurrencyListAsync.failure,
    (state, action): State => ({
      ...state,
      loading: false,
      error: action.payload.error?.message || null,
    })
  )
  .handleAction(
    setSelectedCurrency,
    (state, { payload }): State => ({
      ...state,
      loading: false,
      error: null,
      selectedCurrency: payload,
    })
  );
